import { render, staticRenderFns } from "./SlotColorPickerV2.vue?vue&type=template&id=c05c89ae&scoped=true&"
import script from "./SlotColorPickerV2.vue?vue&type=script&lang=js&"
export * from "./SlotColorPickerV2.vue?vue&type=script&lang=js&"
import style0 from "./SlotColorPickerV2.vue?vue&type=style&index=0&id=c05c89ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05c89ae",
  null
  
)

export default component.exports